// This module is used to take the "amountInfo" part of the URL on the
// receipient page (the part that comes after the user's slug) and attempts
// to parse it into the amount and currency
import easterEggAmounts from './easter-egg-amounts'
import { toCanonicalNumber } from 'amount-utils'
import clientData from 'utils/client-data'
import _ from 'lodash'

const currencyRegex = /[A-Za-z]{3}/

// This is the main function that performs the amount info extraction.
function extractAmountInfo(amountString = '') {
  const decodedAmountString = decodeURI(amountString)
  const easterEggResult = getEasterEggInfo(decodedAmountString)
  if (easterEggResult) {
    return easterEggResult
  }

  const primaryCurrencyCode = _.get(
    clientData,
    'recipientSlugDetails.slugDetails.userInfo.primaryCurrencyCode',
    'USD',
  )

  const supportedCurrencyCode = _.get(clientData, 'supportedCurrencies', [])

  let [currency = 'USD'] =
    decodedAmountString.match(currencyRegex) || [primaryCurrencyCode] || []

  const amountOnly = decodedAmountString.replace(currency, '') || '0'

  // if the currency code passed by user is not supported then default back to the recipients user currency code
  if (!supportedCurrencyCode.includes(currency.toUpperCase())) {
    currency = primaryCurrencyCode
  }

  return {
    amount: Number(toCanonicalNumber(amountOnly)).toFixed(2),
    currency: currency.toUpperCase(),
  }
}

export function isValidNumber(amountString = '') {
  const { amount } = extractAmountInfo(amountString)
  return !isNaN(amount)
}

// This will check whether the amountString is referencing one of the easter
// eggs (emoji/mathmatical constants/etc.)
function getEasterEggInfo(amountString) {
  const supportedCurrencyCode = _.get(clientData, 'supportedCurrencies', [])
  const primaryCurrencyCode = _.get(
    clientData,
    'recipientSlugDetails.slugDetails.userInfo.primaryCurrencyCode',
    'USD',
  )

  // `pizza`
  if (easterEggAmounts[amountString]) {
    return {
      amount: easterEggAmounts[amountString],
      currency: primaryCurrencyCode,
    }
  }

  // `pizzaUSD`
  const firstPart = amountString.slice(0, amountString.length - 3)
  if (easterEggAmounts[firstPart]) {
    let currency = amountString.slice(-3).toUpperCase()

    // if the currency code passed by user is not supported then default back to the recipients user currency code
    if (!supportedCurrencyCode.includes(currency.toUpperCase())) {
      currency = primaryCurrencyCode
    }

    return {
      amount: easterEggAmounts[firstPart],
      currency,
    }
  }

  // `USDpizza`
  const secondPart = amountString.slice(3)
  if (easterEggAmounts[secondPart]) {
    let currency = amountString.slice(0, 3).toUpperCase()

    // if the currency code passed by user is not supported then default back to the recipients user currency code
    if (!supportedCurrencyCode.includes(currency.toUpperCase())) {
      currency = primaryCurrencyCode
    }
    return {
      amount: easterEggAmounts[secondPart],
      currency,
    }
  }
  return null
}

export { extractAmountInfo }
